<template>
  <div class="chat-item-container" :class="{ 'has-status': chat.status }">
    <div class="status-indicator" v-if="chat.status" :style="{ backgroundColor: chat.status.color }"></div>
    <div class="chat-item-content">
      <div class="avatar">
        <div v-if="!chat.photoUrl" class="avatar-placeholder">
          {{ getInitials() }}
        </div>
        <img v-else :src="chat.photoUrl" alt="Avatar" class="avatar-image">
      </div>
      
      <div class="chat-details">
        <div class="chat-header">
          <div class="chat-name-container">
            <div class="chat-name">{{ chatName }}</div>
            <div v-if="chat.status" class="chat-status-badge" :style="{ backgroundColor: chat.status.color + '20', color: chat.status.color }">
              {{ chat.status.name }}
            </div>
          </div>
          <div class="chat-time">{{ formatTime(chat.lastMessageDate) }}</div>
        </div>
        
        <div class="chat-preview">
          <div class="message-preview">
            <span v-if="chat.assignedTo" class="assigned-badge" :title="`Назначено: ${assignedName}`">
              <i class="fas fa-user-check"></i>
              <span class="assigned-name">{{ assignedName }}</span>
            </span>
            <span v-else class="message-text">{{ messagePreview }}</span>
          </div>
          <div v-if="chat.unreadCount > 0" class="unread-badge">
            {{ chat.unreadCount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatItem',
  props: {
    chat: {
      type: Object,
      required: true
    }
  },
  computed: {
    chatName() {
      if (this.chat.firstName || this.chat.lastName) {
        return `${this.chat.firstName} ${this.chat.lastName}`.trim();
      }
      return this.chat.username ? `@${this.chat.username}` : this.chat.telegramId;
    },
    messagePreview() {
      if (this.chat.lastMessage) {
        return this.chat.lastMessage.text || 'Медиа';
      }
      return 'Нет сообщений';
    },
    assignedName() {
      if (!this.chat.assignedTo) return '';
      console.log(this.chat.assignedTo);

      return this.chat.assignedTo.name;
    }
  },
  methods: {
    getInitials() {
      if (this.chat.firstName && this.chat.firstName.length > 0) {
        return this.chat.firstName.charAt(0).toUpperCase();
      }
      if (this.chat.username && this.chat.username.length > 0) {
        return this.chat.username.charAt(0).toUpperCase();
      }
      return '#';
    },
    formatTime(timestamp) {
      if (!timestamp) return '';
      
      const date = new Date(timestamp);
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      
      // Если сообщение от сегодня, показываем только время
      if (date >= today) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      }
      
      // Если сообщение от вчера, показываем "Вчера"
      if (date >= yesterday && date < today) {
        return 'Вчера';
      }
      
      // Иначе показываем дату
      return date.toLocaleDateString();
    }
  }
}
</script>

<style scoped>
.chat-item-container {
  display: flex;
  padding: 10px 15px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
  position: relative;
  max-width: 100%;
}

.chat-item-container.has-status {
  padding-left: 11px;
}

.status-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  margin-right: 11px;
}

.chat-item-content {
  display: flex;
  flex: 1;
  min-width: 0;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background-color: #e0e0e0;
  color: #757575;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.chat-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  width: 100%;
}

.chat-name-container {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.chat-name {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 5px;
}

.chat-status-badge {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 10px;
  white-space: nowrap;
  margin-right: 5px;
}

.chat-time {
  color: #757575;
  font-size: 12px;
  white-space: nowrap;
  margin-left: 5px;
  flex-shrink: 0;
}

.chat-preview {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.message-preview {
  color: #757575;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
}

.assigned-badge {
  display: inline-flex;
  align-items: center;
  margin-right: 5px;
  color: #4caf50;
  white-space: nowrap;
  flex-shrink: 0;
}

.assigned-name {
  margin-left: 3px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.message-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.unread-badge {
  background-color: #2196f3;
  color: white;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-left: 5px;
  padding: 0 5px;
  flex-shrink: 0;
}
</style> 